<template>
  <div class="rainshutdown-container g-button-modal">
    <h5 class="rainshutdown-header title">
      Rainshutdown
    </h5>
    <div class="rainshutdown-input">
      <div class="two-columns">
        <div class="two-columns__column">
          <div class="two-columns__column--boxed">
            <input
              v-model="SetRainShutDownDays"
              name=""
              placeholder="0"
              maxlength="2"
              class="rainshutdown-input-days g-btn g-btn--rounded wide"
            >
          </div>
        </div>
        <div class="two-columns__column">
          <div class="two-columns__column--boxed">
            <input
              v-model="SetRainShutDownHours"
              name=""
              placeholder="0"
              maxlength="2"
              class="rainshutdown-input-hours g-btn g-btn--rounded wide"
            >
          </div>
        </div>
      </div>
      <h4 class="rainshutdown-days title">
        Days
      </h4>
      <h4 class="rainshutdown-hours title">
        Hours
      </h4>
      <div class="two-columns">
        <div class="two-columns__column">
          <button
            class="rainshutdown-add-day g-btn g-btn--rounded wide"
            @click="AddOneDay()"
          >
            + 1 day
          </button>
          <button
            class="rainshutdown-sub-day g-btn g-btn--rounded wide"
            @click="SubOneDay()"
          >
            - 1 day
          </button>
        </div>
        <div class="two-columns__column">
          <button
            class="rainshutdown-add-one g-btn g-btn--rounded wide"
            @click="AddOne()"
          >
            + 1 hour
          </button>
          <button
            class="rainshutdown-sub-one g-btn g-btn--rounded wide"
            @click="SubOne()"
          >
            - 1 hour
          </button>
        </div>
      </div>
    </div>
    <hr>
    <div class="rainshutdown-start-cancel">
      <button
        class="rainshutdown-start g-btn g-btn--rounded wide"
        @click="Start()"
      >
        Start
      </button>
      <button
        class="rainshutdown-clear g-btn g-btn--rounded wide"
        @click="Clear()"
      >
        Clear
      </button>
      <button
        class="rainshutdown-stop g-btn g-btn--rounded wide"
        @click="Stop()"
      >
        Stop
      </button>
    </div>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'
export default {
  name: 'RainShutDown',
  mixins: [SocketHandler],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return{
      SetRainShutDown: 0,
      Hours: 0,
      Days: 0,
      SetRainShutDownDays: 0,
      SetRainShutDownHours: 0,
      rainShutDownStarted: false,
    }
  },
  watch: {
    SetRainShutDown() {
      if(Math.floor(this.SetRainShutDown / 24) > 0) {
        this.SetRainShutDownDays = Math.floor(this.SetRainShutDown / 24)
        this.SetRainShutDownHours = (this.SetRainShutDown % 24)
      } else {
        this.SetRainShutDownDays = 0
        this.SetRainShutDownHours = this.SetRainShutDown
      }
    },
    SetRainShutDownDays() {
      var inputDaysTest = this.SetRainShutDownDays

      if(inputDaysTest.toString().match(/^[0-9]{0,2}$/)) {
        if(this.SetRainShutDownDays > 41) {
          this.SetRainShutDownDays = 41
          this.SetRainShutDownHours = 15
          this.SetRainShutDown = (this.SetRainShutDownDays * 24) + (this.SetRainShutDownHours)
        } else if(this.SetRainShutDownDays === 41 && this.SetRainShutDownHours > 15) {
          this.SetRainShutDownDays = 41
          this.SetRainShutDownHours = 15
          this.SetRainShutDown = (this.SetRainShutDownDays * 24) + (this.SetRainShutDownHours)
        } else {
          this.SetRainShutDown = (this.SetRainShutDownDays * 24) + this.SetRainShutDownHours
        }
      } else {
        this.SetRainShutDownDays = 0
        this.SetRainShutDown = (this.SetRainShutDownDays * 24) + this.SetRainShutDownHours
      }
    },
    SetRainShutDownHours(Hours) {
      var inputHoursTest = this.SetRainShutDownHours

      if(inputHoursTest.toString().match(/^[0-9]{0,2}$/)) {
        if(this.SetRainShutDownHours > 23 && this.SetRainShutDownDays < 42) {
          this.SetRainShutDownHours = 23
        } else if(this.SetRainShutDownHours > 15 && this.SetRainShutDownDays === 41) {
          this.SetRainShutDownHours = 15
        }
      } else {
        this.SetRainShutDownHours = 0
        this.SetRainShutDown = (this.SetRainShutDownDays * 24) + this.SetRainShutDownHours
      }
    }
  },
  mounted() {
    this.SetRainShutDownDays = this.ModalData.data.RemainDays
    this.SetRainShutDownHours = this.ModalData.data.RemainHours
    this.SetRainShutDown = (this.SetRainShutDownHours + (this.SetRainShutDownDays) * 24)
    this.IsRainShutdownStarted(this.SetRainShutDown)
  },
  methods: {
    Start() {
      if(this.SetRainShutDown === 0) return

      var time = (this.SetRainShutDown * 3600)
      this.Stop()

      this.store.setData('rainShutDown.showRainShutDownSpinner', 'showStarter')
      setTimeout(() => {
        this.SocketMessageSend({component: 'Rainshutdown', command: 'Start', runtime: time})
        this.rainShutDownStarted = true
        this.$emit('CloseModal')
      }, 1000)
    },
    Clear() {
      this.SetRainShutDown = 0
    },
    Stop() {
      this.store.setData('rainShutDown.showRainShutDownSpinner', 'showStopper')
      this.SocketMessageSend({component: 'Rainshutdown', command: 'Stop'})
      this.SetRainShutDown = 0
      this.$emit('CloseModal')
    },
    AddOne() {
      if(this.SetRainShutDown < 999) {
        this.SetRainShutDown++
      }
    },
    SubOne() {
      if(this.SetRainShutDown > 0) {
        this.SetRainShutDown--
      }
    },
    AddOneDay() {
      if(this.SetRainShutDown <= 975) {
        this.SetRainShutDown += 24
      }
    },
    SubOneDay() {
      if(this.SetRainShutDown >= 24) {
        this.SetRainShutDown -= 24
      }
    },
    IsRainShutdownStarted(Time) {
      if(Time > 0) {
        this.rainShutDownStarted = true
      } else {
        this.rainShutDownStarted = false
      }
    }
  }
}
</script>

<style lang="scss">
  .rainshutdown-start-cancel {
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    justify-content: stretch;

    > button.g-btn {
      min-width: 0 !important;
      width: auto !important;
      flex: 1;

      &.rainshutdown-start {
        background-color: $color-green-ok;
        color: $color-white;
      }
      &.rainshutdown-clear {
      }
      &.rainshutdown-stop {
      }
    }
  }
</style>
